import { Component,OnInit} from '@angular/core';  


@Component({
  selector: 'app-form-rule',
  styleUrls: ['../rule.scss'],
  templateUrl: 'ruledashboard.component.html'
})

export class RuleDashboardComponent implements OnInit {
    ngOnInit(){
      
    }  
 
}

